import { create, type StateCreator } from "zustand";
import {
  createJSONStorage,
  persist,
  type PersistOptions,
} from "zustand/middleware";

export interface PersistedStoreOptions<T> {
  name: string;
  partialize?: (state: T) => Partial<T>;
  version?: number;
  migrate?: (persistedState: unknown, version: number) => T | Partial<T>;
}

export function persistedStore<T>(
  initializer: StateCreator<T>,
  options: PersistedStoreOptions<T>,
) {
  const persistOptions: PersistOptions<T, Partial<T>> = {
    name: `oms-${options.name}`,
    storage: createJSONStorage(() => localStorage),
    version: options.version ?? 1,
    partialize: options.partialize,
    migrate: options.migrate,
  };
  return create<T>()(persist(initializer, persistOptions));
}
